import { Form } from 'react-bootstrap'

interface IReadOnlySelectPropTypes {
  onChange: () => void
  value: boolean
  disabled: boolean
}

// TODO - Consolidate this with the other ReceivesRfpEmailsCheckbox.
export default function ReadOnlySelect({
  onChange,
  value,
  disabled,
}: IReadOnlySelectPropTypes) {
  return (
    <fieldset>
      <Form.Group className="fluid">
        <Form.Check type="checkbox" name="user-readOnly">
          <Form.Check.Label>
            <Form.Check.Input
              type="checkbox"
              className="mt-1"
              name="user-readOnly"
              checked={value}
              onChange={onChange}
              disabled={disabled}
            />
            Read Only
          </Form.Check.Label>
        </Form.Check>
      </Form.Group>
    </fieldset>
  )
}
